import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';
import * as Styles from './styles';
import { getDD_MM_YYYY } from 'utils/date';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { MPosContext } from 'utils/context';

const GSTDetailsUpdateModal = () => {
    const { userDetails, gstDetailsSubmitAction } = useContext(MPosContext);
    const currentDate = new Date();
    const router = useRouter();

    const onClickContinueHandler = () => {
        if (!gstDetailsSubmitAction) {
            router.push('/logout');
        } else {
            router.push(`/embedded/${userDetails.partner_id}/gst-details`);
        }
    };

    if (!gstDetailsSubmitAction) {
        return (
            <Styles.Wrapper>
                <Styles.WarningTitleContainer>
                    <Image
                        src={getImageBasePath('/icons/errorRed.svg')}
                        alt=""
                        width={25}
                        height={25}
                    />
                    <Styles.WarningTitleText>
                        Urgent: Your GST has expired
                    </Styles.WarningTitleText>
                </Styles.WarningTitleContainer>
                <Styles.Text>
                    GST number for your dealer is invalid or expired. To
                    continue transacting on Acko, request your dealer to kindly
                    update the GST number. Once the dealer completes this step,
                    you will be able to start selling plans.
                </Styles.Text>
                <Styles.ButtonContainer>
                    <PrimaryButton
                        style={{ width: '100px' }}
                        isFullWidth={false}
                        size={'large'}
                        onClick={onClickContinueHandler}
                    >
                        Logout
                    </PrimaryButton>
                </Styles.ButtonContainer>
            </Styles.Wrapper>
        );
    }
    return (
        <Styles.Wrapper>
            <Styles.WarningTitleContainer>
                <Image
                    src={getImageBasePath('/icons/errorRed.svg')}
                    alt=""
                    width={25}
                    height={25}
                />
                <Styles.WarningTitleText>
                    Urgent: Your GST has expired
                </Styles.WarningTitleText>
            </Styles.WarningTitleContainer>
            <Styles.Text>
                We checked your GST number on {getDD_MM_YYYY(currentDate)} and
                it&apos;s no longer valid. To continue creating new plans and
                earning commissions, you need to update GST details.
            </Styles.Text>
            <Styles.ButtonContainer>
                <PrimaryButton
                    style={{ width: '100px' }}
                    isFullWidth={false}
                    size={'large'}
                    onClick={onClickContinueHandler}
                >
                    Continue
                </PrimaryButton>
            </Styles.ButtonContainer>
            <Styles.Text>
                You won&apos;t be able to create new plans until your GST is
                updated
            </Styles.Text>
        </Styles.Wrapper>
    );
};

export default GSTDetailsUpdateModal;
